var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (['super_admin', 'teacher', 'accountant','education_manager'].includes(_vm.role.type))?_c('v-list',{staticClass:"py-0"},[_c('Report')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }